<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Fatura Listesi</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
            <a target="_self" v-bind:href="'#/fatura/serbestfatura/id?isl=yeni'">
              <v-btn flat> <span class="hidden-sm-and-down"> Serbest Fatura Ekle </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </a>
            <v-menu bottom left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="faturaiptaldialog()">
                  <v-list-tile-title>Fatura İptal Et</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="faturaserinodialogac()">
                  <v-list-tile-title>Fatura Seri/No Değiştir</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>

          <v-container fluid="">
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">trending_up</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  Serbest
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{serbestAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  Coper
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{coperAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md4>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">Bilet</div>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">: {{biletAdet}} </div>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    Toplam Adet :{{ToplamAdetbilcopser}}
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#4CAF50" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">queue</v-icon>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm10 md10>
                      <v-card-title primary-title="">


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  Kağıt Fatura </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{kagıtAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  E-Fatura
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{efaturaAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md6>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">E-Arşiv</div>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md6>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">: {{earsivAdet}} </div>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    Toplam Adet: {{ToplamAdetkagefatears}}
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#FF6F00" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">poll</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>


                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm5 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  Toplam KDV
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm7 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{toplamKDV}}₺
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm5 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm7 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex md4>
                              <v-list-tile-title>
                                <div class="font-weight-medium subheading  white--text title mb-1"></div>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex md8>
                              <v-list-tile-title>
                                <div class="font-weight-medium subheading  white--text title mb-1"></div>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    Toplam Tutar: {{ToplamKDVMat}}₺
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid="">
            <v-form ref="formtarih" v-model="valid" lazy-validation>
              <v-layout row wrap="">
                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                    v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                    v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                </v-flex>
                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList(1,kayitadet,siralamatipi,true)" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-layout align-center="" fill-height>
                        <v-progress-circular indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </div>
                    <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                      color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                      <span>Arama Filtresi Ekle</span>
                    </v-tooltip>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-flex v-show="kayitvarmi" xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md9>
                      <v-layout align-center="" fill-height="">
                        <div class=" font-weight-large grey--text title ">
                          &nbsp; {{recordcount}} <span v-if="secilenkayitlar.length>0" class=" font-weight-large red--text title ">
                           /  {{secilenkayitlar.length}} kayıt seçildi.. </span>
                        </div>
                      </v-layout>
                    </v-flex>
                    <v-flex v-show="kayitvarmi" xs12 sm12 md2>
                      <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1" v-model="siralamatipi"
                        item-text="text" item-value="value" label="Sıralama Tipi"></v-select>
                    </v-flex>
                    <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                      <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet"
                        item-text="text" item-value="value" label="Göster"></v-select>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-layout v-if="kayitvarmi" justify-center="" align-center>
                          <v-checkbox v-model="tumunuseckaldir" label="Tümünü Seç"></v-checkbox>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-layout>

                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-list two-line>
                    <template v-for="item in items">
                      <v-layout row wrap v-bind:key="item.FaturaBilgi">
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout justify-center="" align-center>
                                <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item"></v-checkbox>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                        <!-- <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout justify-center="" align-center>
                                <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item"></v-checkbox>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card> -->
                        <v-flex xs12 sm4 md2>
                          <v-layout align-start justify-start row fill-height>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-sub-title>
                                    <div class="font-weight-bold  "> Fat Seri/No

                                    </div>
                                  </v-list-tile-sub-title>
                                  <v-list-tile-sub-title>
                                    <div class="font-weight-bold caption  ">
                                      {{item.GenelBilgileri.OnayFaturaNo}}
                                    </div>
                                  </v-list-tile-sub-title>
                                  <v-layout row align-center justify-start>

                                    <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COP'" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white">hotel</v-icon>
                                      </v-avatar>
                                      Coper
                                    </v-chip>
                                    <v-chip small="" color="green" v-if="item.GenelBilgileri.Tip=='BLT'" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white">airplanemode_active</v-icon>
                                      </v-avatar>
                                      Bilet
                                    </v-chip>
                                    <v-chip small="" color="info" v-if="item.GenelBilgileri.Tip=='SER'" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white">filter_none</v-icon>
                                      </v-avatar>
                                      Serbest
                                    </v-chip>

                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md1>
                          <v-layout align-start justify-start="">
                            <v-card flat="">
                              <v-list-tile>

                                <v-list-tile-content>
                                  <v-layout row wrap align-center="" justify-center="" column="">
                                    <v-list-tile-title>
                                      <v-layout column="" align-center="">
                                        <div class="font-weight-bold red--text caption">
                                          {{item.TarihBilgileri.FaturaTarihi}}
                                        </div>
                                      </v-layout>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      <v-layout column="" align-center>
                                        <!-- <div v-if="item.GenelBilgileri.FaturaTip=='0'" class="font-weight-large grey--text subheading ">
                                      Kağıt
                                    </div>
                                    <div v-if="item.GenelBilgileri.FaturaTip=='1'" class="font-weight-large grey--text subheading ">
                                      E-Fatura
                                    </div>
                                    <div v-if="item.GenelBilgileri.FaturaTip=='2'" class="font-weight-large grey--text subheading ">
                                      E-Arşiv
                                    </div> -->
                                        <v-chip small v-if="item.GenelBilgileri.FaturaTip=='0'" class="white--text"
                                          color="orange">Kağıt</v-chip>
                                        <v-chip small v-if="item.GenelBilgileri.FaturaTip=='1'" class="white--text"
                                          color="pink">E-Fatura</v-chip>
                                        <v-chip small v-if="item.GenelBilgileri.FaturaTip=='2'" class="white--text"
                                          color="red">E-Arşiv</v-chip>
                                      </v-layout>
                                    </v-list-tile-sub-title>

                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm4 md2>
                          <v-layout column="" align-center>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          Fatura Durumu
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>

                                        <v-chip small="" color="red" v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus!='Fatura Beklemede' &&  item.GenelBilgileri.EFaturaShowID.FaturaStatus!='Alıcı Onayladı' &&  item.GenelBilgileri.EFaturaShowID.FaturaStatus!='Fatura Gönderildi'"
                                          text-color="white">
                                          <v-avatar>
                                            <v-icon color="white">radio_button_unchecked</v-icon>
                                          </v-avatar>
                                          İşlem Yok
                                        </v-chip>

                                        <v-chip small="" color="pink" v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Beklemede'"
                                          text-color="white">
                                          <v-avatar>
                                            <v-icon color="white">access_alarm</v-icon>
                                          </v-avatar>
                                          {{item.GenelBilgileri.EFaturaShowID.FaturaStatus}}
                                        </v-chip>

                                        <v-chip small="" color="green" v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Alıcı Onayladı'"
                                          text-color="white">
                                          <v-avatar>
                                            <v-icon color="white">done_all</v-icon>
                                          </v-avatar>
                                          {{item.GenelBilgileri.EFaturaShowID.FaturaStatus}}
                                        </v-chip>

                                        <v-chip small="" color="info" v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Gönderildi'"
                                          text-color="white">
                                          <v-avatar>
                                            <v-icon color="white">send</v-icon>
                                          </v-avatar>
                                          {{item.GenelBilgileri.EFaturaShowID.FaturaStatus}}
                                        </v-chip>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md3>
                          <v-layout>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Müşteri Kodu: {{item.GenelBilgileri.Cari.Kod}}
                                        </div>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption">
                                          Müşteri Ünvanı: {{item.GenelBilgileri.Cari.Unvan}}
                                        </div>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                        <v-layout>
                                          <div class="font-weight-bold caption">
                                            VKN:/T.C.: <span v-if="item.GenelBilgileri.Cari.TCNo!=null">{{item.GenelBilgileri.Cari.TCNo}}</span>/
                                            <span v-if="item.GenelBilgileri.Cari.VergiNo!=null">{{item.GenelBilgileri.Cari.VergiNo}}</span>
                                          </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                        <div class="font-weight caption ">
                                        </div>
                                      </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm4 md2>
                          <v-layout>

                            <v-flex xs12 sm6 md6>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Tutar:
                                        </div>
                                      </v-list-tile-sub-title>
                                      <!-- <v-list-tile-sub-title>
                                                                <div class="font-weight caption ">
                                                                   Matrah:
                                                                </div>
                                                            </v-list-tile-sub-title> -->
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold  caption">
                                          Kalan Tutar:
                                        </div>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold  caption">
                                          Kdv
                                        </div>
                                      </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-layout row justify-end="" fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title>
                                        <v-layout align-center="" justify-end>
                                          <div class="font-weight-bold  caption ">
                                            {{item.tutarlar.Tutar}} ₺ </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                      <!-- <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end="">
                                                                    <div class="font-weight caption ">
                                                                        0.0 ₺
                                                                    </div>
                                                                </v-layout>
                                                            </v-list-tile-sub-title> -->
                                      <v-list-tile-sub-title>
                                        <v-layout align-center="" justify-end="">
                                          <div class="font-weight-bold  caption ">
                                            {{item.tutarlar.Kalan}}
                                            ₺
                                          </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                        <v-layout align-center="" justify-end="">
                                          <div class="font-weight-bold  caption ">
                                            {{item.tutarlar.Kdv}} ₺
                                          </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm4 md1>
                          <v-layout align-end="" justify-center="" fill-height="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout>
                                    <v-flex xs12 sm4 md3>
                                      <v-btn small icon class="mx-0" @click="efaturagoster(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID)">
                                        <v-icon large="" color="info">line_weight</v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm4 md3>
                                      <v-btn small icon class="mx-0" @click="reportbrobas(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID,item.GenelBilgileri.EFaturaShowID.PdfID)">
                                        <v-icon large="" color="info">print</v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm4 md5>
                                      <v-layout>
                                        <a target="_blank" small v-bind:href="'#/fatura/faturadetay/id?' + 'guid=' + item.GenelBilgileri.EFaturaShowID.EFaturaGuid">
                                          <v-btn icon>
                                            <v-icon color="info">search</v-icon>
                                          </v-btn>
                                        </a>
                                        <v-btn small icon class="mx-0" @click="git(item.GenelBilgileri)">
                                          <v-icon color="info">edit</v-icon>
                                        </v-btn>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider :key="item.id" inset></v-divider>
                    </template>
                  </v-list>
                </v-flex>

              </v-card>
            </v-flex>
          </v-layout>
          <v-container>
            <v-layout justify-center="">
              <template v-if="vmodelpagination">
                <div class="text-xs-center">
                  <v-container>
                    <v-layout justify-center>
                      <v-flex xs8>
                        <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </template>
            </v-layout>
          </v-container>

          <!-- <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                  :search="search3">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr item>

                      <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                      <td class="text-xs-left">{{ props.item.Faturano }}</td>
                      <td class="text-xs-left">{{ props.item.FaturaTarih}}</td>
                      <td class="text-xs-left">{{ props.item.Tip}}</td>
                      <td class="text-xs-left">{{ props.item.FaturaVade}}</td>
                      <td class="text-xs-left">{{ props.item.Kalan}}</td>
                      <td class="text-xs-left">{{ props.item.Tutar }}</td>
                      <td class="text-xs-left">{{ props.item.Kdv }}</td>
                      <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                      <v-btn icon class="mx-0" @click="kayitcek(props.item)">
                        <v-icon color="red">line_weight</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="efaturagoster(props.item)">
                        <v-icon color="teal">line_weight</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="git(props.item.FaturaTarih,props.item.Cari.Kod,props.item.Tip,props.item.FaturaSeri,props.item.Faturano)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search3 }}" found no results.
                  </v-alert>
                </v-data-table>
              </v-card>
      </v-flex>
          </v-layout> -->


          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>


          <v-dialog v-model="dialogsor" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Uyarı !</v-card-title>
              <v-card-text>Seçili faturaları iptal etmek istediğinize emin misiniz?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="dialogsor=false">İptal</v-btn>
                <v-btn color="info" flat @click="faturaiptalet()">Tamam</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="600px">
            <v-card color="grey lighten-2">

              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <div class="flex md12">
                    <v-layout>
                      <v-text-field hide-details="" style="padding-right:5px;" v-model="SerbestFatura.BaslangicFaturaNo"
                        label="Fatura No-1" required> </v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFatura.BitisFaturaNo" label="Fatura No-2" required>
                      </v-text-field>

                    </v-layout>
                  </div>

                  <div class="flex md12">

                    <v-autocomplete label="Hesap Kodu " v-model="SerbestFatura.Cari.Kod" clearable :loading="loading"
                      append-icon="search" :items="hesapkodu" item-text="text" cache-items="" item-value="id"
                      :search-input.sync="search"></v-autocomplete>
                  </div>
                  <div class="flex md12">
                    <v-layout>
                      <parainput style="padding-right:3px;" v-model="SerbestFatura.MinTutar" :etiket="'Min Tutar'"
                        :autocomplete="autocomplete"></parainput>

                      <parainput :name="maxtutar" v-model="SerbestFatura.MaxTutar" :etiket="'Max Tutar'" :autocomplete="autocomplete"></parainput>
                    </v-layout>
                  </div>

                  <div class="flex md12">


                    <div class="card__text grey darken-1 white--text">
                      <h3>Opsiyonlar</h3>
                    </div>

                    <v-radio-group hide-details="" v-model="SerbestFatura.FaturaTp" label="Fatura Tipi" column>
                      <v-radio label="Hepsi" value="H"> </v-radio>
                      <v-radio label="Serbest" value="S"></v-radio>
                      <v-radio label="Bilet" value="B"></v-radio>
                      <v-radio label="Coper" value="c"></v-radio>
                    </v-radio-group>

                    <v-checkbox label="Vade Tarihini Kullan" hide-details="" v-model="SerbestFatura.VadeTarihi"></v-checkbox>
                    <v-checkbox label="Sadece Bakiyesi Olan Faturaları Göster" hide-details="" v-model="SerbestFatura.Bakiyeli"></v-checkbox>
                    <v-checkbox label="Cariye Kaydedilmesi İstenmemiş Serbest Faturaları Göster" hide-details=""
                      v-model="SerbestFatura.CariyeKaydedilmeyen"></v-checkbox>
                    <v-checkbox label="Tüm Şirketler" hide-details="" v-model="tumsirketler"></v-checkbox>
                  </div>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>




          <v-dialog v-model="faturaserinoDialog" scrollable persistent="" max-width="300px">
            <v-card color="grey lighten-5">

              <v-card-title>Fatura Seri/No Değiştir</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="formserino" v-model="valid" lazy-validation>
                  <v-layout row="" wrap="">
                    <v-flex xs12 sm12 md12>
                      <v-text-field mask="AAAAAAAAAAAAAAAA" :rules="[v => !!v || 'Lütfen seri giriniz']" label="Fatura Seri"
                        v-model="Faturaseri" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field label="Fatura No" :rules="[v => !!v || 'Lütfen fatura no giriniz']" v-model="Faturano"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="faturaserinoDialog=false">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click="faturaserinodegistir()">Değiştir</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-layout>
      </v-card>
    </v-app>





    <v-dialog scrollable="" max-width="850px">
      <v-card>
        <v-card-title>E-Fatura</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <reportbrosablon ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>




    <v-dialog v-model="faturadialog" scrollable="" max-width="850px">
      <v-card>
        <v-card-title>E-Fatura</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <div class="flex md12">
              <span id="demo2">
              </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>


  </div>


</template>


<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from "@/components/app/customcomp/tarihim"




  export default {
    data() {
      return {
        headers: [{
            text: ' Fatura Seri',
            value: 'FaturaSeri',
            width: '10'
          },
          {
            text: 'Fatura No',
            value: 'Faturano',
            width: '10'
          },
          {
            text: ' Fatura Tarihi',
            value: 'FaturaTarih'
          },
          {
            text: ' Fatura Tipi',
            value: 'Tip'
          },
          {
            text: ' Vade Tarihi',
            value: 'FaturaVade'
          },
          {
            text: 'Kalan',
            value: 'Kalan'
          },
          {
            text: 'Tutar',
            value: 'Tutar'
          },
          {
            text: 'KDV',
            value: 'Kdv'
          },
          {
            text: 'Cari',
            value: 'Cari.Kod'
          }

        ],
        aramayapildi: false,
        dialogsor: false,
        valid: true,
        dizayn: null,
        serbestAdet: 0,
        coperAdet: 0,
        biletAdet: 0,
        ToplamAdetbilcopser: 0,
        kagıtAdet: 0,
        efaturaAdet: 0,
        earsivAdet: 0,
        ToplamAdetkagefatears: 0,
        toplamKDV: 0,
        ToplamMatrah: 0,
        ToplamKDVMat: 0,
        tumunuseckaldir: false,
        siralamatipi: 'InvoiceDate',
        kayitsayisi: 0,
        kayitadet: 50,
        recordcount: null,
        kayitvarmi: true,
        searchliste: null,
        listegorunum: true,
        gorunumtipi: 'list',
        tablegorunum: false,
        kayitsayisivmodel: 50,
        kayitsayisi: [{
          text: '50',
          value: 50
        }, {
          text: '100',
          value: 100
        }],
        vmodelpagination: false,
        siralamavmodel: 0,
        siralamatipiitems: [{
          text: 'Tarihe Göre Artan',
          value: 'InvoiceDate'
        }, {
          text: 'Tarihe Göre Azalan',
          value: 'InvoiceDateDesc'
        }, {
          text: 'Cariye Göre Artan',
          value: 'InvoiceCurrentCode'
        }, {
          text: 'Cariye Göre Azalan',
          value: 'InvoiceCurrentCodeDesc'
        }, {
          text: 'Tutara Göre Artan',
          value: 'InvoiceAmount'
        }, {
          text: 'Tutara Göre Azalan',
          value: 'InvoiceAmountDesc'
        }, ],

        filtreticket: [],
        indexsayisi: 10,
        pagenumber: 1,
        sayfalama: 1,
        secilenkayitlar: [],
        tooltip: false,
        el: null,
        SerbestFatura: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          BaslangicFaturaNo: null,
          BitisFaturaNo: null,
          Cari: {
            Kod: null
          },
          MinTutar: 0,
          MaxTutar: 0,
          VadeTarihi: false,
          Bakiyeli: false,
          CariyeKaydedilmeyen: false,
          FaturaTp: 'H',
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'InvoiceDate'
          }

        },
        Faturano: null,
        Faturaseri: null,
        faturaserinoDialog: false,
        faturadialog: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        progress: false,


        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsecbit: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        maxtutar: 'maxtutar',
        autocomplete: 'autocomplete',
        etiket: 'Max Tutar',
        dialogfatura: false,
        mintutar: 'mintutar',
        etiketmin: 'Min Tutar',

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false,
        tooltip: false,
        el: null,

      }
    },
    beforeMount: beforeMount,
    mounted() {
      this.el = this.$refs.fab.$el
    },
    components: {
      'parainput': parainput,
      reportbrosablon,
      tarihcomp
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val) {
        val && this.carigetir2(val)
      },
      'kayitadet': function (valueveriadet) {
        this.getList(1, valueveriadet, this.siralamatipi, false)
      },
      'siralamatipi': function (tip) {
        this.sayfalama = 1;
        this.getList(1, this.kayitadet, tip, false)
      },
      'sayfalama': function (sayfa) {
        this.getList(sayfa, this.kayitadet, this.siralamatipi, false)
      },
      'secilenkayitlar': function (value) {

        if (value.length > 0) {
          var kayitno = value.length - 1
          console.log(kayitno, value[kayitno])
          if (value[kayitno].GenelBilgileri.Tip == 'SER' || value[kayitno].GenelBilgileri.EFaturaShowID.FaturaStatus ==
            'Alıcı Onayladı') {
            this.secilenkayitlar.splice(value.length - 1, 1)
            this.text1 = "Serbest Fatura veya Onaylanmış Faturalara toplu işlem yapamazsınız."
            this.snackbar = true
          } else {

          }
        }

        console.log(this.secilenkayitlar)
      },
      tumunuseckaldir(valsec) {

        console.log('tumunusec'+valsec+this.aramayapildi)

        if (valsec == true && this.aramayapildi == true) {
                  console.log('tumunusec2'+this.aramayapildi)

          this.yedekListInput.Paging.SayfaNo = 0
          this.yedekListInput.Paging.VeriAdet = null
          this.yedekListInput.Paging.SiralamaTip = null
          var params = this.yedekListInput

          console.log('params:', params)
          this.$http.post(auth.API_URL + 'api/Report/InvoiceReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (response.body.FaturaBilgi.length > 0) {
              this.kayitvarmi = true;
              var editdizi = []

              response.body.FaturaBilgi.forEach(element => {

                if (element.Tip == 'SER' || element.EFaturaShowID.FaturaStatus == 'Alıcı Onayladı') {

                } else {

                  var yenikayit = [];

                  yenikayit.GenelBilgileri = element;
                  var tutarlar = {
                    Tutar: element.Tutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    KalanTutar: element.Kalan.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    Kdv: element.Kdv.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                  }
                  yenikayit.tutarlar = tutarlar;
                  var tarih = {
                    FaturaTarihi: tarihkontrol(element.FaturaTarih),
                  }
                  yenikayit.TarihBilgileri = tarih;
                  editdizi.push(yenikayit)
                }

              });

              this.secilenkayitlar = editdizi;
              this.secilenkayitlaryedek = editdizi
              this.aramayapildi = false;

              this.progress = false
              this.load1 = true
              this.vmodelpagination = true;

            } else {
              this.kayitvarmi = false;
              this.load1 = true
              this.items = [];
              this.vmodelpagination = false;
              this.recordcount = ""
              this.text1 = 'Kayıt Bulunamadı....'
              this.snackbar = true
            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true

            }
          })


        } else if (this.aramayapildi == false && valsec == true) {
          this.secilenkayitlar = this.secilenkayitlaryedek;
        } else if (this.aramayapildi == false && valsec == false) {
          this.secilenkayitlar = [];
        }

      },
    },
    methods: {
      faturaiptaldialog() {
        if (this.secilenkayitlar.length > 0) {
          this.dialogsor = true
        } else {
          this.text1 = "Lütfen iptal edilecek faturaları seçiniz"
          this.snackbar = true
        }
      },

      faturaserinodialogac() {
        if (this.secilenkayitlar.length == 1) {
          this.faturaserinoDialog = true
        } else {
          this.text1 = "Fatura seri/no değiştirme işlemini tek kayıt üzerinden yapabilirsiniz..."
          this.snackbar = true
        }
      },

      faturaserinodegistir() {

        if (this.$refs.formserino.validate()) {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var params=null

          this.secilenkayitlar.forEach(element => {

            params = {
              SirketKodu: credentials.SirketKodu,
              FaturaTarihi: element.GenelBilgileri.FaturaTarih,
              FaturaSeri: element.GenelBilgileri.FaturaSeri,
              FaturaNo: element.GenelBilgileri.Faturano,
              YeniFaturaSeri:this.Faturaseri,
              YeniFaturaNo:this.Faturano
            }
          });



          this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceChange', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

              this.text1 = response.body.FaturaResponse
              this.snackbar = true

                            console.log(response.body.FaturaStatus)


            if (response.body.FaturaStatus === true) {
              console.log('girdi')

              this.faturaserinoDialog = false
              this.getList(1, 50, 'InvoiceDate', true)

            } else {

            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-InvoiceChange'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-InvoiceChange'
              this.snackbar = true
            }
          })

        } else {
          this.text1 = 'Fatura Seri/No boş bırakılamaz.'
          this.snackbar = true
        }
      },

      faturaiptalet() {

        var iptaledilecekkayitlar = []

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        this.secilenkayitlar.forEach(element => {
          var kayit = {
            SirketKodu: credentials.SirketKodu,
            FaturaTarihi: element.GenelBilgileri.FaturaTarih,
            FaturaSeri: element.GenelBilgileri.FaturaSeri,
            FaturaNo: element.GenelBilgileri.Faturano,
          }
          iptaledilecekkayitlar.push(kayit)
        });

        var params = iptaledilecekkayitlar

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceCancel', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body[0].FaturaStatus == true) {
            this.dialogsor = false
            this.text1 = 'Fatura iptal işleminiz tamamlandı.'
            this.snackbar = true
            this.getList(1, 50, 'InvoiceDate', true)
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-InvoiceCancel'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceCancel'
            this.snackbar = true
          }
        })
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      carigetir: carigetir,
      carigetir2: carigetir2,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      git: git,
      kayitcek: kayitcek,
      efaturagoster: efaturagoster,
      tarihkontrol: tarihkontrol,
      reportbrobas: reportbrobas,
    },
  }

  function git(kayit) {
    console.log(kayit + 'kayit')
    if (kayit.Tip == "SER") {
      var evraktip = "SF"
      var url = '#/fatura/serbestfatura/id?' + 'ft=' + kayit.FaturaTarih + '&ck=' + kayit.Cari.Kod + '&et=' + evraktip +
        '&es=' +
        kayit.FaturaSeri + '&en=' + kayit.Faturano + '&ner=' + "X" + '&sb=' + true + '&islem=get'
      window.open(url, '_target')
    } else {
      this.text1 = "Lütfen Serbest Fatura Seçiniz"
      this.snackbar = true
    }
  }

  function efaturagoster(v, y) {

    var params = {
      id: y,
      guid: v
    }

    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-FaturaShow'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-FaturaShow'
        this.snackbar = true
      }
    })
  }

  function reportbrobas(v, y, dizaynkod) {

    this.dizayn = dizaynkod;
    console.log(dizaynkod)
    var prm = {
      id: y,
      guid: v
    };
    this.$refs.reportbrosablon.Print(prm).then(
      confirm => {
        // this.status.loading = false;
      },
      confirm => {
        //  this.status.loading = false;
      }
    );
  }

  function tarihkontrol(v) {

    if (v != "0001-01-01T00:00:00") {
      var parts = v.split("T");
      var parts1 = parts[0].split("-");
      return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
    } else {
      return null;
    }
  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapkodu = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function carigetir2(v) {
    if (v.length >= 0) {
      this.loading1 = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.anahesap = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading1 = false
      }, 500)
    }
  }

  function getList(sayfanoo, kayitadett, siralatipp, aramayapildimi) {


    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.progress = true
        this.load1 = false
        this.secilenkayitlar = []
        this.tumunuseckaldir = false

        if (this.tumsirketler === true) {
          this.SerbestFatura.SirketKodu = '0'
        } else {
          this.SerbestFatura.SirketKodu = credentials.SirketKodu
        }

        if (aramayapildimi == true) {
          this.SerbestFatura.BaslangicTarih = this.date
          this.SerbestFatura.BitisTarih = this.date2
          this.SerbestFatura.Paging.VeriAdet = 50
          this.SerbestFatura.Paging.SiralamaTip = 'InvoiceDate'
          this.SerbestFatura.Paging.SayfaNo = 1
          this.yedekfaturaclass = this.SerbestFatura;
        } else {

          this.SerbestFatura = this.yedekfaturaclass;
          this.SerbestFatura.Paging.VeriAdet = kayitadett
          this.SerbestFatura.Paging.SiralamaTip = siralatipp;
          this.SerbestFatura.Paging.SayfaNo = sayfanoo;
        }

        var params = this.SerbestFatura
        this.yedekListInput = this.SerbestFatura;

        this.$http.post(auth.API_URL + 'api/Report/InvoiceReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.aramayapildi = true

          if (response.body.FaturaBilgi.length > 0) {
            this.kayitvarmi = true;
            this.pagenumber = response.body.TotalPage;
            this.vmodelpagination = true;
            this.recordcount = 'Toplam ' + response.body.TotalCount + ' kayıt listelendi';
            this.items = response.body.FaturaBilgi
            this.serbestAdet = response.body.FaturaToplamlar.SerbestFaturaAdet;
            this.coperAdet = response.body.FaturaToplamlar.CoperFaturaAdet;
            this.biletAdet = response.body.FaturaToplamlar.BiletFaturaAdet;
            this.ToplamAdetbilcopser = response.body.FaturaToplamlar.ToplamFaturaAdet;
            this.kagıtAdet = response.body.FaturaToplamlar.FaturaAdet;
            this.efaturaAdet = response.body.FaturaToplamlar.EFaturaAdet;
            this.earsivAdet = response.body.FaturaToplamlar.EArsivAdet;
            this.ToplamAdetkagefatears = response.body.FaturaToplamlar.ToplamFaturaAdet;
            this.toplamKDV = response.body.FaturaToplamlar.ToplamKdv.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.ToplamMatrah = 0;
            this.ToplamKDVMat = response.body.FaturaToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');

            var editdizi = []

            this.items.forEach(element => {

              var yenikayit = [];

              yenikayit.GenelBilgileri = element;

              var tutarlar = {
                Tutar: element.Tutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                KalanTutar: element.Kalan.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                Kdv: element.Kdv.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
              }

              yenikayit.tutarlar = tutarlar;

              var tarih = {
                FaturaTarihi: tarihkontrol(element.FaturaTarih),
              }

              yenikayit.TarihBilgileri = tarih;

              editdizi.push(yenikayit)
            });

            this.items = editdizi;
            this.progress = false
            this.load1 = true
            this.vmodelpagination = true;

          } else {
            this.aramayapildi = false;
            this.kayitvarmi = false;
            this.load1 = true
            this.items = [];
            this.vmodelpagination = false;
            this.recordcount = ""
            this.text1 = 'Kayıt Bulunamadı....'
            this.snackbar = true
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.aramayapildi = false;

            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.aramayapildi = false;

            this.load1 = true

          }
        })

      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }

  function kayitcek(v) {

    var params = {
      id: v.EFaturaShowID.EFaturaID,
      guid: v.EFaturaShowID.EFaturaGuid
    }

    this.$http.post(auth.API_URL + 'api/EFatura/GetFatura', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function getListHtml() {
    this.load = true
    this.load1 = false
    var params = {
      StartDate: this.date,
      EndDate: this.date2
    }
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentHtmlReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mizan.html";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      }
    })
  }

  function getListExcel() {
    this.load = true
    this.load1 = false
    var params = {
      StartDate: this.date,
      EndDate: this.date2
    }
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentExcelReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mizan.xlsx";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      }
    })
  }

  function beforeMount() {
    this.load1 = false
    this.date = helpers.getDateNow()
    this.date2 = helpers.getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.SerbestFatura.SirketKodu = credentials.SirketKodu
    this.SerbestFatura.BaslangicTarih = this.date
    this.SerbestFatura.BitisTarih = this.date2
    this.SerbestFatura.Paging.VeriAdet = 50
    this.SerbestFatura.Paging.SiralamaTip = 'InvoiceDate'
    this.SerbestFatura.Paging.SayfaNo = 1
    this.yedekfaturaclass = this.SerbestFatura;

    this.yedekListInput = this.SerbestFatura;

    var params = this.SerbestFatura


    this.$http.post(auth.API_URL + 'api/Report/InvoiceReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.load1 = true
      if (response.body.FaturaBilgi.length > 0) {
        this.kayitvarmi = true;
        this.aramayapildi=true;
        this.pagenumber = response.body.TotalPage;
        this.vmodelpagination = true;
        this.recordcount = 'Toplam ' + response.body.TotalCount + ' kayıt listelendi';

        this.items = response.body.FaturaBilgi

        this.serbestAdet = response.body.FaturaToplamlar.SerbestFaturaAdet;
        this.coperAdet = response.body.FaturaToplamlar.CoperFaturaAdet;
        this.biletAdet = response.body.FaturaToplamlar.BiletFaturaAdet;
        this.ToplamAdetbilcopser = response.body.FaturaToplamlar.ToplamFaturaAdet;
        this.kagıtAdet = response.body.FaturaToplamlar.FaturaAdet;
        this.efaturaAdet = response.body.FaturaToplamlar.EFaturaAdet;
        this.earsivAdet = response.body.FaturaToplamlar.EArsivAdet;
        this.ToplamAdetkagefatears = response.body.FaturaToplamlar.ToplamFaturaAdet;
        this.toplamKDV = response.body.FaturaToplamlar.ToplamKdv.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
          '$1,');
        this.ToplamMatrah = 0;
        this.ToplamKDVMat = response.body.FaturaToplamlar.ToplamTutar.toFixed(2).replace(
          /(\d)(?=(\d{3})+\.)/g, '$1,');

        var editdizi = []

        this.items.forEach(element => {

          var yenikayit = [];

          yenikayit.GenelBilgileri = element;

          var tutarlar = {
            Tutar: element.Tutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
            KalanTutar: element.Kalan.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
            Kdv: element.Kdv.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
          }

          yenikayit.tutarlar = tutarlar;

          var tarih = {
            FaturaTarihi: tarihkontrol(element.FaturaTarih),
          }

          yenikayit.TarihBilgileri = tarih;

          editdizi.push(yenikayit)
        });

        this.items = editdizi;
        this.load1 = true
        this.vmodelpagination = true;

      } else {
        this.kayitvarmi = false;
        this.load1 = true
        this.vmodelpagination = false;
        this.recordcount = ""
        this.text1 = 'Kayıt Bulunamadı....'
        this.snackbar = true
      }

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      }
    })

  }

  function filtrele() {
    this.dialogfiltre = true
  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false
    this.SerbestFatura.BaslangicFaturaNo = null
    this.SerbestFatura.BitisFaturaNo = null
    this.SerbestFatura.Cari.Kod = null
    this.SerbestFatura.MinTutar = 0
    this.SerbestFatura.MaxTutar = 0
    this.SerbestFatura.FaturaTp = null
    this.SerbestFatura.VadeTarihi = false
    this.SerbestFatura.Bakiyeli = false
    this.SerbestFatura.CariyeKaydedilmeyen = false
    this.tumsirketler = false
  }
</script>

<style>
</style>